<template>
  <el-dialog
    :visible.sync="visible"
    width="600px"
    @close="handleClose"
    custom-class="calculator-dialog"
    append-to-body
    :show-close="true"
  >
    <div slot="title" class="dialog-header">
      <span class="title-text">견적 계산기</span>
    </div>

    <div class="calculator-container">
      <el-form :model="form" label-width="120px" label-position="left">
        <div class="calc-form-grid">
          <el-row :gutter="0" class="form-row">
            <el-col :span="24" class="form-cell">
              <el-form-item label="가로 (cm)">
                <el-input v-model="form.width" placeholder="가로 길이 입력" size="medium" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="form-row">
            <el-col :span="24" class="form-cell">
              <el-form-item label="세로 (cm)">
                <el-input v-model="form.length" placeholder="세로 길이 입력" size="medium" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="form-row">
            <el-col :span="24" class="form-cell">
              <el-form-item label="높이 (cm)">
                <el-input v-model="form.height" placeholder="높이 입력" size="medium" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="form-row">
            <el-col :span="24" class="form-cell">
              <el-form-item label="발송 요일">
                <el-select v-model="form.shippingDayGroup" placeholder="선택하세요" style="width: 100%" size="medium">
                  <el-option label="월/수/금 (65 USD/CBM)" value="mon_wed_fri"></el-option>
                  <el-option label="화/목/토/일 (72 USD/CBM)" value="tue_thu_sat_sun"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="action-buttons">
          <el-button @click="resetForm" class="btn-reset">초기화</el-button>
          <el-button type="primary" @click="calculate" class="btn-calculate">계산하기</el-button>
        </div>

        <div class="results-list">
          <div class="result-item">
            <div class="label-group">
              <span>실제 부피 (CBM)</span>
            </div>
            <div class="value-text">{{ results.actualCbm.toFixed(4) }} CBM</div>
          </div>
          <div class="result-item">
            <div class="label-group">
              <span>청구 부피 (CBM)</span>
            </div>
            <div class="value-text">{{ results.chargedCbm.toFixed(2) }} CBM</div>
          </div>
          <div class="result-item total-highlight">
            <div class="label-group">
              <span>국제배송비 (예상)</span>
              <i class="el-icon-question help-icon"></i>
            </div>
            <div class="value-text large blue">{{ results.intlShippingFee | currency }}</div>
          </div>
        </div>

        <div class="footer-notice">
          * 본 운비계산기는 실제 계측 중량 및 부피에 따라 차이가 발생할 수 있습니다.
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CalculatorModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const today = new Date().getDay();
    const defaultDayGroup = (today === 1 || today === 3 || today === 5) ? 'mon_wed_fri' : 'tue_thu_sat_sun';
    return {
      visible: this.value,
      form: {
        width: '',
        length: '',
        height: '',
        shippingDayGroup: defaultDayGroup
      },
      results: {
        actualCbm: 0,
        chargedCbm: 0,
        intlShippingFee: 0
      }
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('input', val);
    }
  },
  filters: {
    currency(value) {
      if (!value) return '$ 0.00';
      return '$ ' + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    resetForm() {
      const today = new Date().getDay();
      const defaultDayGroup = (today === 1 || today === 3 || today === 5) ? 'mon_wed_fri' : 'tue_thu_sat_sun';
      this.form = {
        width: '',
        length: '',
        height: '',
        shippingDayGroup: defaultDayGroup
      };
      this.results = {
        actualCbm: 0,
        chargedCbm: 0,
        intlShippingFee: 0
      };
    },
    calculate() {
      const width = parseFloat(this.form.width) || 0;
      const length = parseFloat(this.form.length) || 0;
      const height = parseFloat(this.form.height) || 0;

      const actualCbm = (width * length * height) / 1000000;
      
      let chargedCbm = 0;
      if (actualCbm > 0) {
        if (actualCbm <= 0.5) {
          chargedCbm = 0.5;
        } else {
          chargedCbm = actualCbm + 0.01;
        }
      }

      const rate = this.form.shippingDayGroup === 'mon_wed_fri' ? 65 : 72;
      const intlShippingFee = chargedCbm * rate;

      this.results = {
        actualCbm,
        chargedCbm,
        intlShippingFee
      };
    }
  }
};
</script>

<style scoped>
.calculator-container {
  padding: 0 10px;
}

.dialog-header {
  text-align: center;
  border-bottom: 2px solid #333;
  padding-bottom: 15px;
  margin: 0 -20px 20px;
}

.title-text {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}

/* Form Grid Styling */
.calc-form-grid {
  border: 1px solid #eee;
  border-bottom: none;
}

.form-row {
  border-bottom: 1px solid #eee;
  display: flex;
}

.form-cell {
  padding: 10px 15px;
  background: #fdfdfd;
  flex: 1;
}

.form-cell.border-right {
  border-right: 1px solid #eee;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.help-icon {
  color: #007bff;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.value-display {
  font-weight: 600;
  color: #333;
  font-size: 15px;
}

.unit-text {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}

.category-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-select {
  background-color: #e8f0fe;
  color: #0055d4;
  border: 1px solid #c2d7ff;
  font-weight: 600;
}

.hint-text {
  font-size: 12px;
  color: #999;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 30px 0;
}

.btn-reset {
  min-width: 130px;
  height: 44px;
  border-radius: 22px;
  font-weight: 600;
  color: #666;
}

.btn-calculate {
  min-width: 130px;
  height: 44px;
  border-radius: 22px;
  font-weight: 600;
  background-color: #0055d4;
  border-color: #0055d4;
}

/* Results List */
.results-list {
  border-top: 1px solid #ddd;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
}

.result-item.total-highlight {
  background-color: #f8f9fb;
  border-bottom: 2px solid #eee;
}

.label-group {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #333;
}

.value-text {
  font-size: 15px;
  color: #333;
}

.value-text.large {
  font-size: 18px;
  font-weight: 700;
}

.value-text.blue {
  color: #0055d4;
}

.footer-notice {
  margin-top: 20px;
  font-size: 12px;
  color: #999;
  font-style: italic;
}

/* Element UI Overrides */
::v-deep .calculator-dialog {
  border-radius: 8px;
}

::v-deep .el-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  font-weight: 600;
  color: #444;
  line-height: 1.2 !important;
  padding-right: 15px !important;
  flex-shrink: 0;
}

::v-deep .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
  line-height: 1.2 !important;
}

::v-deep .el-input__inner {
  border-radius: 4px;
  height: 36px;
  border-color: #ddd;
}

::v-deep .el-select .el-input__inner {
  padding-right: 30px;
}
</style>
